export default {
  UNSPLASH: 'unsplash',
  ISTOCK: 'istock',
};
